<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="套餐名称">
                <a-input v-model="queryParam.packageName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="归档存储状态">
                <a-select placeholder="请选择" v-model="queryParam.archiveStorageClass" style="width: 100%" allow-clear>
                  <a-select-option :key="item.id" v-for="item in archiveStorageClass"> {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="存储续费类型">
                <a-select placeholder="请选择" v-model="queryParam.renewType" style="width: 100%" allow-clear>
                  <a-select-option :key="item.id" v-for="item in renewType"> {{ item.name }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="状态">
                <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option :value="0"> 正常 </a-select-option>
                  <a-select-option :value="1"> 失效 </a-select-option>
                  <a-select-option :value="2"> 数据删除 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="value"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeTime" />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <template>
          <a-button
            type="primary"
            @click="handleExport"
            v-hasPermi="['961c4bf184878299c0760852dfce6474e:0:e']"
            :disabled="value.length ? false : true">
            导出
          </a-button>
        </template>
      </div>
      <CreateForm ref="CreateForm" @ok="getList"></CreateForm>

      <!-- 详情抽屉组件 -->
      <DetailDrawer ref="detailDrawer" />

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        class="center-table">
        <span slot="statNo" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.statNo">
            <span class="text-ellipsis">{{ record.statNo || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="sourceType" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.sourceType | formStatus(sourceType)">
            <span class="text-ellipsis">{{ record.sourceType | formStatus(sourceType) }}</span>
          </a-tooltip>
        </span>
        <span slot="renewType" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.renewType | formStatus(renewType)">
            <span class="text-ellipsis">{{ record.renewType | formStatus(renewType) }}</span>
          </a-tooltip>
        </span>
        <span slot="archiveStorageClass" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.archiveStorageClass | formStatus(archiveStorageClass)">
            <span class="text-ellipsis">{{ record.archiveStorageClass | formStatus(archiveStorageClass) }}</span>
          </a-tooltip>
        </span>
        <span slot="renewAmount" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.renewAmount">
            <span class="text-ellipsis">¥{{ record.renewAmount || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="archiveSceneCount" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.archiveSceneCount">
            <span class="text-ellipsis">{{ record.archiveSceneCount || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="expireTime" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.expireTime">
            <span class="text-ellipsis">{{ record.expireTime || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="createTime" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.createTime">
            <span class="text-ellipsis">{{ record.createTime || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="remark" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.remark">
            <span class="text-ellipsis">{{ record.remark || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="action" slot-scope="text, record">
          <div class="action-right">
            <a @click="handleDetail(record)" v-hasPermi="['961c4bf184878299c0760852dfce6474q:0:q']">详情</a>
            <a-divider type="vertical" v-hasPermi="['961c4bf184878299c0760852dfce6474r:0:r']" />
            <a @click="handleDelete(record, undefined)" v-hasPermi="['961c4bf184878299c0760852dfce6474r:0:r']">删除</a>
          </div>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj, editStatus } from '@/api/VR/expiredStatistics'
import CreateForm from './modules/CreateForm.vue'
import DetailDrawer from './modules/DetailDrawer.vue' // 引入详情组件
import { listTenant } from '@/api/system/tenant'
import { tableMixin } from '@/store/table-mixin'
import parameter from '@/mixins/parameter'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'Work',
  components: {
    CreateForm,
    DetailDrawer, // 注册详情组件
  },
  mixins: [tableMixin, parameter],
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    ...mapGetters(['userTentant', 'infoUser']),
  },
  data() {
    return {
      list: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      value: [],
      advanced: false,
      loading: false,
      selectedRowKeys: [],
      columns: [
        {
          title: '统计单号',
          dataIndex: 'statNo',
          width: '120px',
          align: 'center',
          scopedSlots: { customRender: 'statNo' },
        },
        {
          title: '来源存储类型',
          width: '130px',
          dataIndex: 'sourceType',
          scopedSlots: { customRender: 'sourceType' },
          align: 'center',
        },
        {
          title: '存储续费类型',
          dataIndex: 'renewType',
          scopedSlots: { customRender: 'renewType' },
          width: '120px',
          align: 'center',
        },
        {
          title: '归档存储状态',
          dataIndex: 'archiveStorageClass',
          scopedSlots: { customRender: 'archiveStorageClass' },
          width: '120px',
          align: 'center',
        },
        {
          title: '续费金额(元)',
          dataIndex: 'renewAmount',
          width: '108px',
          align: 'center',
          scopedSlots: { customRender: 'renewAmount' },
        },
        {
          title: '归档场景数量',
          dataIndex: 'archiveSceneCount',
          width: '120px',
          align: 'center',
          scopedSlots: { customRender: 'archiveSceneCount' },
        },
        {
          title: '到期时间',
          dataIndex: 'expireTime',
          width: '120px',
          align: 'center',
          scopedSlots: { customRender: 'expireTime' },
        },

        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
    }
  },
  methods: {
    // 详情功能
    handleDetail(record) {
      this.$refs.detailDrawer.show(record)
    },

    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    handleDeletes(row) {
      var that = this
      const text = row.status == 0 ? '是否确认启用此数据' : '是否确认禁用此数据'
      this.$confirm({
        title: text,
        onOk() {
          return editStatus({ id: row.id }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() { },
      })
    },
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() { },
      })
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.value = []
      this.handleQuery()
    },
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'vr/storage/expire/stat/renew/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() { },
      })
    },
    onChangeTime(e) {
      this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
      this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
  },
  created() {
    if (this.userType == 1) {
      this.columns.splice(1, 1)
    }
    if (this.userType == 2) {
      this.columns.splice(2, 1)
    }
    this.getList()
  },
  mounted() { },
}
</script>

<style scoped>
.table-operations {
  margin-bottom: 16px;
}

.table-operations .ant-btn {
  margin-right: 8px;
}

.ant-table-pagination {
  margin-top: 16px;
  text-align: right;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-page-search-wrapper .ant-form-item {
  margin-bottom: 16px;
}

.center-table .ant-table-thead > tr > th {
  text-align: center;
  white-space: nowrap;
}

.center-table .ant-table-tbody > tr > td {
  text-align: center;
  white-space: nowrap;
}

.center-table .ant-table-thead > tr > th,
.center-table .ant-table-tbody > tr > td {
  vertical-align: middle;
}

.center-table .ant-dropdown-link {
  display: inline-block;
}

.ant-table-pagination {
  text-align: center;
}

.center-table {
  width: 100%;
}

.center-table .ant-table-container {
  width: 100%;
}

.center-table .ant-table-content {
  text-align: center;
}

.text-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.action-right {
  display: flex;
  justify-content: flex-end;
  padding-right: 8px;
}
</style>
